<template>
    <el-select v-model="value" style="width: 100%">
        <el-option label="AZN" value="1" />
        <el-option label="USD" value="2" />
        <el-option label="EUR" value="3" />
    </el-select>
</template>
<script>
export default {
    props: {
        propvalue: Number,
        ctp: Number
    },
    data() {
        return {
            value: this.propvalue == 0 ? null : this.propvalue,
            object: []
        }
    },
    watch: {
        value() {
            this.$emit('change-value', this.value)
        }
    },
    created() {
        //None

    }
}
</script>